import React from 'react'
import DropDownList from '../DropDownList/DropDownList'
import { IDropDownListItem } from '../../../Types/DropDownList/IDropDownListItem'
import { GetColour, GetGradeColour } from '../../../Data/ColourData'
import { IGrade } from '../../../Types/IGrade'
import styles from './GradeSelector.module.css'

// Legacy grade data for backward compatibility
const GradeData : IDropDownListItem[] = [
    {
        text: "Red",
        colour: GetColour("Red"),
        textColour: "black",
        value: undefined
    },
    {
        text: "Amber",
        colour: GetColour("Yellow"),
        textColour: "black",
        value: undefined
    },
    {
        text: "Green",
        colour: GetColour("Green"),
        textColour: "white",
        value: undefined
    },
    {
        text: "Blue",
        colour: GetColour("Blue"),
        textColour: "white",
        value: undefined
    }
]

type GradeSelectorProps = {
    grade: string,
    options?: IDropDownListItem[],
    onChange?: (selectedItem: IDropDownListItem) => void;
    readOnly?: boolean,
    gradeProfileId?: string,
    showProgressBar?: boolean
}

const GradeSelector = ({grade, options, onChange, readOnly, showProgressBar = false} : GradeSelectorProps) => {
    // Use the provided options (which should come from questionnaire.gradeOptions) or fall back to legacy data
    const displayOptions: IDropDownListItem[] = options ?? GradeData;

    // Debug logging to see what data we're receiving
    React.useEffect(() => {
        console.log('=== GradeSelector Debug Info ===');
        console.log('Current grade:', grade);
        console.log('Options received:', options);
        console.log('Display options being used:', displayOptions);
        
        if (options && options.length > 0) {
            console.log('First option details:', {
                text: options[0].text,
                colour: options[0].colour,
                textColour: options[0].textColour,
                value: options[0].value,
                progressValue: options[0].progressValue
            });
        }
        console.log('===============================');
    }, [grade, options, displayOptions]);

    if(readOnly){
        // Find the selected grade to get its color
        const selectedGrade = displayOptions.find(option => option.value === grade || option.text === grade);
        const gradeColour = selectedGrade?.colour || GetGradeColour(grade);
        const textColour = selectedGrade?.textColour || (GetGradeColour(grade) === "#52BFA2" ? "white" : "black");

        return (
            <div className={styles.gradeDisplay}>
                <div 
                    className={styles.gradeLabel}
                    style={{
                        padding: "10px", 
                        background: gradeColour,
                        color: textColour
                    }}
                >
                    {grade}
                </div>
                {showProgressBar && selectedGrade?.progressValue !== undefined && (
                    <div className={styles.progressBarContainer}>
                        <div 
                            className={styles.progressBarFill}
                            style={{ 
                                width: `${selectedGrade.progressValue}%`,
                                backgroundColor: gradeColour
                            }}
                        />
                    </div>
                )}
            </div>
        )
    } else {
        return (
            <div className={styles.gradeSelectorContainer}>
                <DropDownList 
                    onChange={onChange} 
                    placeholder={'Select a grade'} 
                    data={displayOptions} 
                    value={grade}
                />
                {showProgressBar && grade && (
                    <div className={styles.progressBarContainer}>
                        <div 
                            className={styles.progressBarFill}
                            style={{ 
                                width: `${displayOptions.find(opt => opt.value === grade || opt.text === grade)?.progressValue || 0}%`,
                                backgroundColor: displayOptions.find(opt => opt.value === grade || opt.text === grade)?.colour || "#24394F"
                            }}
                        />
                    </div>
                )}
            </div>
        )
    }
}

export default GradeSelector